/**
 * External dependencies
 */
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import layoutId from './layout-id';

export default combineReducers({
	layoutId,
});
